export default {"src":"/_next/static/media/PPSX.85bb5e7a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};